import React, { useCallback } from 'react';
import ProProfileHeaderReview from '@z-components/organisms/ProProfileHeader/ProProfileHeaderReview';
import ClientReviewCardGroup from 'components/organisms/ClientReviewCardGroup';
import { ProFeedback } from 'modules/marketing-pages/marketing-page.types';
import style from './style.module.scss';

interface Props {
  featureFlags: { isReviewsQAEnabled: boolean };
  reviews: {
    // 5 length array-
    // rate1 to rate5 are from index 0 to index 4
    counts: Array<number>;
    list: Array<ProFeedback>;
    total: number;
  };
  averageRating: number;
}

type FeedbackCountsByRating = {
  rate1: number;
  rate2: number;
  rate3: number;
  rate4: number;
  rate5: number;
  totalRate: number;
};

type RateOption = 'rate1' | 'rate2' | 'rate3' | 'rate4' | 'rate5';

const ProReviewContent = ({ featureFlags, reviews, averageRating }: Props) => {
  // This method is for convert [0,0,0,0,0] like array to FeedbackCountsByRating type
  const convertReview = useCallback(
    (counts: Array<number>, total: number): FeedbackCountsByRating => {
      const feedbackCountsByRating = {} as FeedbackCountsByRating;

      counts.forEach((reviewCount, index) => {
        feedbackCountsByRating[`rate${index + 1}` as RateOption] = reviewCount;
      });

      feedbackCountsByRating.totalRate = total;

      return feedbackCountsByRating;
    },
    []
  );

  const feedbackCountsByRating = convertReview(reviews.counts, reviews.total);

  return (
    <div className={style['pro-review-content']}>
      <ProProfileHeaderReview
        feedbackCountsByRating={feedbackCountsByRating}
        isDesktop={false}
        rating={averageRating}
        reviewCount={feedbackCountsByRating.totalRate}
      />
      <ClientReviewCardGroup
        isReviewsQAEnabled={featureFlags.isReviewsQAEnabled}
        reviews={reviews.list}
        centerSeeMore={true}
        variant={''}
      />
    </div>
  );
};

export default ProReviewContent;
